// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import createSvgIcon from '../../utils/createSvgIcon.js';
import { ReactComponent as AlertTriangleIcon } from '../../assets/feather/alert-triangle.svg';

export default createSvgIcon(AlertTriangleIcon, 'AlertTriangleIcon');
